import React from 'react';
import qs from 'qs';

import config from '../config';

import IconGoogle from 'icons/icon-google';
import IconHarvest from 'icons/icon-harvest';
import IconZoomus from 'icons/icon-zoomus';
import IconGitHub from 'icons/icon-github';
import IconMicrosoft from 'icons/icon-microsoft';
import IconSlack from 'icons/icon-slack';
import IconWebex from 'icons/icon-webex';

const APP_DOMAIN = config.APP_DOMAIN === 'localhost' ? 'niftyqa.com' : config.APP_DOMAIN;
const REDIRECT_URI_BASE = `https://${APP_DOMAIN}/external-redirect`;

export const EXTERNAL_ACCOUNTS_OPTIONS = [
    {
        provider: 'github',
        name: 'GitHub',
        types: ['user', 'team'],
        icon: <IconGitHub />,
        connectUrl: `https://github.com/login/oauth/authorize?${qs.stringify({
            redirect_uri: `${REDIRECT_URI_BASE}/github`,
            client_id: config.GITHUB_CLIENT_ID,
            scope: 'repo'
        })}`
    },
    {
        provider: 'google',
        hasConfigure: true,
        name: 'Google Drive & Calendar',
        icon: <IconGoogle />,
        types: ['user'],
        connectUrl: `https://accounts.google.com/o/oauth2/v2/auth?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/google`,
            client_id: config.GOOGLE_CONFIG.CLIENT_ID,
            access_type: 'offline',
            scope: ['userinfo.profile', 'userinfo.email', 'drive', 'calendar.readonly', 'calendar.app.created', 'calendar.events'].map(scope => `https://www.googleapis.com/auth/${scope}`).join(' '),
            nonce: 'Nifty',
            prompt: 'consent'
        })}`
    },
    {
        provider: 'google',
        key: 'googleMeet',
        name: 'Google Meet',
        icon: <IconGoogle />,
        types: ['user'],
        connectUrl: `https://accounts.google.com/o/oauth2/v2/auth?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/google`,
            client_id: config.GOOGLE_CONFIG.CLIENT_ID,
            access_type: 'offline',
            scope: ['userinfo.profile', 'userinfo.email', 'drive', 'calendar.readonly', 'calendar.app.created', 'calendar.events'].map(scope => `https://www.googleapis.com/auth/${scope}`).join(' '),
            nonce: 'Nifty',
            prompt: 'consent'
        })}`
    },
    {
        provider: 'harvest',
        name: 'Harvest',
        icon: <IconHarvest />,
        types: ['team']
    },
    {
        provider: 'microsoft',
        hasConfigure: true,
        name: 'Microsoft Suite',
        types: ['user'],
        icon: <IconMicrosoft />,
        connectUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/microsoft`,
            scope: ['user.read', 'offline_access', 'openid', 'profile', 'files.read.all', 'calendars.readWrite'].join(' '),
            client_id: config.MICROSOFT_CONFIG.CLIENT_ID,
        })}`
    },
    {
        provider: 'microsoft',
        key: 'microsoftMeet',
        name: 'Microsoft Teams/Skype',
        types: ['user'],
        icon: <IconMicrosoft />,
        connectUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/microsoft`,
            scope: ['user.read', 'offline_access', 'openid', 'profile', 'files.read.all', 'calendars.readWrite'].join(' '),
            client_id: config.MICROSOFT_CONFIG.CLIENT_ID,
        })}`
    },
    {
        provider: 'slack',
        name: 'Slack',
        types: ['user'],
        icon: <IconSlack />,
        connectUrl: 'https://slack.com/apps/A018JHQSHRR-nifty',
        noState: true
        // connectUrl: `https://slack.com/oauth/v2/authorize?${qs.stringify({
        //     // redirect_uri: `${REDIRECT_URI_BASE}/slack`,
        //     client_id: config.SLACK_CLIENT_ID,
        //     scope: 'app_mentions:read,chat:write,workflow.steps:execute,commands'
        // })}`
    },
    config.WEBEX_AVAILABLE ? {
        provider: 'webex',
        name: 'Webex',
        types: ['user'],
        icon: <IconWebex />,
        connectUrl: `https://webexapis.com/v1/authorize?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/webex`,
            client_id: config.WEBEX_CLIENT_ID,
            scope: 'meeting:schedules_write meeting:recordings_read meeting:recordings_write meeting:preferences_read meeting:preferences_write meeting:preferences_write meeting:admin_schedule_read meeting:admin_schedule_write meeting:admin_recordings_read meeting:admin_recordings_write meeting:admin_transcripts_read meeting:admin_preferences_write meeting:admin_preferences_read meeting:transcripts_read spark:all'
        })}`
    } : null,
    {
        provider: 'zoom',
        name: 'Zoom',
        types: ['team', 'user'],
        icon: <IconZoomus />,
        connectUrl: `https://zoom.us/oauth/authorize?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/zoom`,
            client_id: config.ZOOM_CLIENT_ID
        })}`
    }
].filter(Boolean);

export const SSO_ACCOUNTS_OPTIONS = [
    {
        provider: 'google',
        name: 'Google SSO',
        icon: <IconGoogle />,
        connectUrl: `https://accounts.google.com/o/oauth2/v2/auth?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/google`,
            client_id: config.GOOGLE_CONFIG.CLIENT_ID,
            access_type: 'offline',
            scope: ['userinfo.profile', 'userinfo.email',].map(scope => `https://www.googleapis.com/auth/${scope}`).join(' '),
            nonce: 'Nifty',
            prompt: 'consent'
        })}`
    },
    {
        provider: 'microsoft',
        name: 'Microsoft SSO',
        icon: <IconMicrosoft />,
        connectUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${qs.stringify({
            response_type: 'code',
            redirect_uri: `${REDIRECT_URI_BASE}/microsoft`,
            scope: ['user.read', 'offline_access', 'openid', 'profile', 'email'].join(' '),
            client_id: config.MICROSOFT_CONFIG.CLIENT_ID,
        })}`
    },
]

export const getExternalAccountOptions = provider => EXTERNAL_ACCOUNTS_OPTIONS.find(account => account.provider === provider);

export const getOAuthStateParam = (token, isTeam) => {
    const type = isTeam ? 'tt' : 'mt';
    return `${type}~${token}`;
}
